/**
 * Very basic provider for everything that needs to configured on runtime
 */
angular.module('Itao.IndicatorMap').provider('mapConfig', function () {
  'use strict';
  var config = {
    templateBasePath: '/templates/',
    widgetExport: {
      cssUrl: location.origin + '/vendor/itao/itaohyperion/Resources/Public/JavaScript/Hyperion/dist/css/hyperion.css',
      remoteUrl: 'http://localhost:8081/v1/generateImage'
    },
    registeredUserMode: false,
    styling: {
      default: {
        weight: 1,
        opacity: 1,
        color: 'white',
        dashArray: '3',
        fillOpacity: 0.7,
        fillColor: '#333333',
        complexColorSet: ['rgba(35,187,30,1)','rgba(35,187,30,.8)','rgba(35,187,30,.6)','rgba(35,187,30,.4)','rgba(35,187,30,.2)','rgba(35,187,30,.1)']
      },
      hover: {
        weight: 1,
        dashArray: '0',
        fillOpacity: 1
      },
      selected: {
        weight: 2,
        dashArray: '0',
        color: 'black'
      }
    },
    defaultLabels: {
      showId: false,
      showTitle: true,
      showValue: false
    },
    chartColors: [
      '#1B9E77',
      '#D95F02',
      '#7570B3',
      '#E7298A',
      '#66A61E',
      '#E6AB02',
      '#A6761D',
      '#666666'
    ],
    chartColorAt: function(number){
      return config.chartColors[number % config.chartColors.length];
    },
    tileLayer: {
      url: 'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpandmbXliNDBjZWd2M2x6bDk3c2ZtOTkifQ._QA7i5Mpkd_m30IGElHziw',
      attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
      '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
      'Imagery © <a href="http://mapbox.com">Mapbox</a>',
    },
    defaultBaseLayer: null,
    numberOfScales: 6,
    defaultSelectedClassMethod: 'width',
    defaultGridWidgetHeight: 1,
    axisMaxValue: null,
    absoluteIndicatorsDecimalPlaces: 0,
    relativeIndicatorsDecimalPlaces: 1,
    availableDataLayerTypeUids: [],
    showIndicatorTypeInMapHover: false,
    redLines: [],
    avgKey: 'avg',
    avgName: 'Durchschnitt'
  };
  return {
    setConfig: function (configName, value) {
      config[configName] = value;
    },
    $get: function () {
      return config;
    }
  };
});
